import React from 'react';
import PropTypes from 'prop-types';

/**
 * ResolutionFeedbackPopup Component
 * Shows a feedback popup asking if the AI's response was helpful
 * Displays below a specific message with Yes/No buttons
 */
const ResolutionFeedbackPopup = ({ 
  messageId, 
  onYes, 
  onNo, 
  onDismiss 
}) => {
  const handleYes = (e) => {
    e.stopPropagation();
    onYes(messageId);
  };

  const handleNo = (e) => {
    e.stopPropagation();
    onNo(messageId);
  };

  const handleDismiss = (e) => {
    e.stopPropagation();
    if (onDismiss) {
      onDismiss(messageId);
    }
  };

  return (
    <div 
      className="flex flex-col gap-2 animate-fadeIn"
      role="dialog"
      aria-labelledby="resolution-feedback-title"
    >
      <div className="flex items-center justify-between gap-3">
        <p 
          id="resolution-feedback-title"
          className="text-sm font-medium text-gray-700 dark:text-gray-300"
        >
          Did this help?
        </p>
        {onDismiss && (
          <button
            onClick={handleDismiss}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
            aria-label="Dismiss feedback"
          >
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              className="h-4 w-4" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M6 18L18 6M6 6l12 12" 
              />
            </svg>
          </button>
        )}
      </div>
      
      <div className="flex gap-2">
        <button
          onClick={handleYes}
          className="flex-1 px-4 py-2 text-sm font-medium text-white bg-black hover:bg-gray-800 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
          aria-label="Yes, this was helpful"
        >
          Yes
        </button>
        <button
          onClick={handleNo}
          className="flex-1 px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2"
          aria-label="No, this was not helpful"
        >
          No
        </button>
      </div>
    </div>
  );
};

ResolutionFeedbackPopup.propTypes = {
  messageId: PropTypes.string.isRequired,
  onYes: PropTypes.func.isRequired,
  onNo: PropTypes.func.isRequired,
  onDismiss: PropTypes.func,
};

export default ResolutionFeedbackPopup;

